import { Injectable, OnDestroy } from '@angular/core';
import { CmpsDialog, CmpsDialogRef } from '@cmps/ng-uikit';

import { useDispatcher, useStore } from '../../../store.decorator';
import { BlFocus } from '../core';

import { BlDialogComponent } from './bl-dialog.component';
import { blDialogReducer } from './bl-dialog.reducer';
import { BlDialogState } from './bl-dialog.state';
import { BlDialogData } from './model/bl-dialog-data.model';
import { reload } from './state/reload.action';

@Injectable({ providedIn: 'root' })
export class BlDialogService implements OnDestroy {
    state: BlDialogState;

    private _ref: CmpsDialogRef<BlDialogComponent, any>;

    constructor(private readonly _dialog: CmpsDialog) {
        useStore(this, 'coaching.behaviourLibrary', blDialogReducer);

        useDispatcher(this, reload({}));
    }

    ngOnDestroy(): void {
        this.close();
    }

    open(focus: BlFocus): void {
        if (this._ref != null && !this._ref.closed) {
            return;
        }
        const data: BlDialogData = {
            focus,
        };
        this._ref = this._dialog.open(BlDialogComponent, {
            disableOverlayOverflowHidden: true,
            overlayClass: 'cmps-coaching-bl-dialog--overlay-class',
            portalClass: 'cmps-coaching-bl-dialog--portal-class',
            portalWrapperClass: 'cmps-coaching-bl-dialog--portal-wrapper-class',
            disableBackdrop: true,
            movable: false, // not compatible with placement option
            resizable: false, // not compatible with placement option
            placement: 'top-left',
            data,
        });
    }

    close(): void {
        this._ref?.close();
    }
}
